import { Instagram, Youtube, Facebook, MapPin, Phone } from "lucide-react";
import { LOGO_URL, PHONE, CENTROS, WHATSAPP_URL } from "../../lib/constants";

export default function Footer() {
    return (
        <footer
            data-testid="main-footer"
            className="relative bg-[#030303] border-t border-white/5 pt-20 pb-10 overflow-hidden"
        >
            {/* Big motivational phrase */}
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <div className="border-b border-white/10 pb-16 mb-12">
                    <span className="font-display tracking-[0.4em] text-xs text-brand-orange">
                        // F YOU MANIFESTO
                    </span>
                    <h3 className="font-display text-5xl sm:text-6xl md:text-8xl lg:text-9xl mt-4 leading-[0.85] tracking-tighter text-brand-text">
                        TU TRANSFORMACIÓN
                        <br />
                        EMPIEZA{" "}
                        <span className="orange-text">HOY.</span>
                    </h3>
                </div>

                <div className="grid lg:grid-cols-12 gap-10 mb-14">
                    <div className="lg:col-span-4">
                        <div className="flex items-center gap-3">
                            <img
                                src={LOGO_URL}
                                alt="F You Gestión Deportiva"
                                className="h-14 w-14 object-contain"
                            />
                            <div>
                                <div className="font-display text-2xl tracking-tight text-brand-text">
                                    F YOU
                                </div>
                                <div className="font-display text-[10px] tracking-[0.35em] text-brand-gold">
                                    GESTIÓN DEPORTIVA S.L.
                                </div>
                            </div>
                        </div>
                        <p className="mt-5 text-sm text-brand-muted max-w-sm leading-relaxed">
                            F You Gestión Deportiva S.L. — Entrenamiento personal
                            premium en Madrid Sur. Disciplina, método y resultados
                            reales para personas comprometidas con su mejor versión.
                        </p>
                        <div className="mt-6 flex gap-3">
                            {[Instagram, Youtube, Facebook].map((Icon, i) => (
                                <a
                                    key={i}
                                    href="#"
                                    data-testid={`footer-social-${i}`}
                                    className="w-11 h-11 border border-white/10 hover:border-brand-orange hover:bg-brand-orange hover:text-black text-brand-muted flex items-center justify-center transition-all"
                                    aria-label="Red social"
                                >
                                    <Icon size={18} />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-5">
                        <div className="font-display tracking-[0.3em] text-xs text-brand-orange mb-5">
                            CENTROS
                        </div>
                        <ul className="space-y-4">
                            {CENTROS.map((c) => (
                                <li
                                    key={c.id}
                                    className="flex items-start gap-3 text-sm"
                                >
                                    <MapPin
                                        size={14}
                                        className="mt-1 text-brand-gold shrink-0"
                                    />
                                    <div>
                                        <span className="font-display text-brand-text tracking-wide">
                                            {c.nombre.toUpperCase()}
                                        </span>
                                        <span className="text-brand-muted">
                                            {" "}— {c.direccion}, {c.cp}
                                        </span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="font-display tracking-[0.3em] text-xs text-brand-orange mb-5">
                            CONTACTO
                        </div>
                        <a
                            href={`tel:${PHONE.replace(/\s/g, "")}`}
                            data-testid="footer-phone"
                            className="flex items-center gap-3 text-brand-text hover:text-brand-orange transition-colors mb-3"
                        >
                            <Phone size={14} className="text-brand-gold" />
                            <span className="font-display tracking-wider">
                                {PHONE}
                            </span>
                        </a>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noreferrer"
                            data-testid="footer-whatsapp"
                            className="inline-block mt-4 bg-brand-orange hover:bg-brand-orangeHover text-black font-display tracking-wider text-xs px-5 py-3 transition-all"
                        >
                            HABLAR POR WHATSAPP
                        </a>
                    </div>
                </div>

                <div className="border-t border-white/5 pt-7 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-brand-muted">
                    <span>
                        © {new Date().getFullYear()} F You Gestión Deportiva
                        S.L. Todos los derechos reservados.
                    </span>
                    <span className="font-display tracking-[0.3em] text-brand-gold">
                        MADE TO TRANSFORM · MADRID
                    </span>
                </div>
            </div>
        </footer>
    );
}
